import BaseValidator from 'services/validations/base-validator';

class PlayersQuantityValidForEachStackItemValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {legacyControlledHitterStacking} = this.dependencies;

        const firstGroupItems = legacyControlledHitterStacking.getFirstGroupItems();
        const firstGroupPlayersQuantity = legacyControlledHitterStacking.getFirstGroupPlayersQuantity();

        this.validatePlayersQuantityInItems(firstGroupItems, firstGroupPlayersQuantity);

        if (this.hasErrors() || !legacyControlledHitterStacking.isDoubleStackModeEnabled()) {
            return;
        }

        const secondGroupItems = legacyControlledHitterStacking.getSecondGroupItems();
        const secondGroupPlayersQuantity = legacyControlledHitterStacking.getSecondGroupPlayersQuantity();

        this.validatePlayersQuantityInItems(secondGroupItems, secondGroupPlayersQuantity);
    }

    private validatePlayersQuantityInItems(items, groupPlayersQuantity): void {
        for (let item of items) {
            const itemPlayersQuantity = this.calcItemPlayersQuantity(item.playerIds);

            if (itemPlayersQuantity > 0 && itemPlayersQuantity < groupPlayersQuantity) {
                this.addError(
                    'Please make sure you have selected enough players for stacks and pay attention if some of them are excluded.',
                );
                break;
            }
        }
    }

    private calcItemPlayersQuantity(playerIds): number {
        // @ts-ignore
        const {players} = this.dependencies;

        let itemPlayersQuantity = 0;
        playerIds.map((playerId) => {
            const player = players.getPlayer(playerId);

            if (player && !player.isExcludedAnywhere()) {
                itemPlayersQuantity++;
            }
        });

        return itemPlayersQuantity;
    }
}

export default PlayersQuantityValidForEachStackItemValidator;
